import { Controller } from "@hotwired/stimulus"

// Kosten drawer: the Schadensmeldung picker belongs to one asset, so picking the asset in the
// Erfassung table reloads the picker's Turbo frame for it (AssetCostsController#damage_options).
export default class extends Controller {
  static values = { url: String }

  costableChanged(event) {
    const frame = this.element.querySelector("turbo-frame#asset_cost_damage_field")
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("costable_key", event.target.value)
    frame.setAttribute("src", url.toString())
  }
}
